module.exports = __webpack_public_path__ + "static/media/ic_close_blue.1c63ca3b.svg";